import { Injectable } from "@angular/core";
import { DbTableDefinition } from "src/app/_services/persistence/db-persistence/db-table-definition";

@Injectable({
  providedIn: 'root'
})
export class LocalBranchTypesDbTableDefinition extends DbTableDefinition {
    tableName = 'local_branchTypes';
    tableStructure = `(id BIGINT(20) PRIMARY KEY null,
      databag LONGTEXT,
      name TEXT NOT NULL,
      shortname TEXT);`;

      constructor() {
        super();
        // Add UpdateStatements to Map
      }
}